const featuresLabels = {
	goodCalls: {
		label: 'eCallMe! – Good Calls',
		items: {
			defaultNotifications: 'Default Notifications',
			customNotifications: 'Custom Notifications',
			customLogos: 'Custom Logos',
		},
	},
	fraudCalls: {
		label: 'eCallMe! – Fraud Calls',
		items: {
			customLogos: 'Custom Logos',
		},
	},
	scheduler: {
		label: 'Scheduler',
		items: {
			scheduleCall: 'Schedule a Call ',
		},
	},
	analytics: {
		label: 'Analytics',
		items: {
			view: 'View Only',
			alarms: 'Alarms (Receive through Email & SMS)',
			customizeThresholds: 'Custom Thresholds',
		},
	},
	rating: {
		label: 'Rating',
		items: {
			rateCall: 'Collect Ratings',
		},
	},
	marketing: {
		label: 'Marketing',
		items: {
			unicast: 'Unicast',
			broadcast: 'Broadcast',
			multicast: 'Multicast (group of people)',
		},
	},
};

export default (licenseSettings) => {
	if (!licenseSettings || !licenseSettings?.features) {
		return null;
	}

	const { features } = licenseSettings;

	return Object
		.keys(featuresLabels)
		.map((featureKey) => {
			if (features[featureKey]) {
				return {
					label: featuresLabels[featureKey]?.label,
					items: Object
						.keys(featuresLabels[featureKey]?.items)
						.map((subFeatureKey) => {
							if (features[featureKey] && (features[featureKey][subFeatureKey] !== undefined)) {
								return {
									label: featuresLabels[featureKey].items[subFeatureKey],
									isActive: features[featureKey][subFeatureKey],
								};
							} else {
								return false;
							}
						})
						.filter(Boolean),
				}
			} else {
				return false;
			}
		})
		.filter(Boolean)
};

